var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33008 0H49.433V33.9706H3.33008V0Z",
    fill: "#E6ECFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6389 22.6471H34.0654V33.9706H31.6389V22.6471Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.433 20.2206V22.6471L31.6389 22.6471V20.2206H49.433Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7199 11.3235H24.7034V16.3235H19.6621V18.3235H24.7034V23.3236H26.7199V18.3235H31.7612V16.3235H26.7199V11.3235Z",
    fill: "#57C0A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0664 22.6471H52.6693V43.6765H34.0664V22.6471Z",
    fill: "#E6ECFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3318 32.3569H39.1704C38.5852 32.3569 38.1094 32.8292 38.1094 33.4092C38.1094 33.9896 38.5852 34.4615 39.1704 34.4615H47.3318C47.917 34.4615 48.3928 33.9896 48.3928 33.4092C48.3928 32.8292 47.917 32.3569 47.3318 32.3569Z",
    fill: "#618AEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3318 27.5H39.1704C38.5852 27.5 38.1094 27.9723 38.1094 28.5523C38.1094 29.1327 38.5852 29.6046 39.1704 29.6046H47.3318C47.917 29.6046 48.3928 29.1327 48.3928 28.5523C48.3928 27.9723 47.917 27.5 47.3318 27.5Z",
    fill: "#618AEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3318 37.2138H39.1704C38.5852 37.2138 38.1094 37.6857 38.1094 38.2661C38.1094 38.8461 38.5852 39.318 39.1704 39.318H47.3318C47.917 39.318 48.3928 38.8461 48.3928 38.2661C48.3928 37.6857 47.917 37.2138 47.3318 37.2138Z",
    fill: "#618AEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.512 35.5857L30.258 40.2928C30.6517 40.6834 30.6517 41.3165 30.258 41.707C29.8642 42.0976 29.2258 42.0976 28.8321 41.707L26.5203 39.4141V48.1715C26.5203 49.7173 27.1394 51.1998 28.2415 52.2929C29.3435 53.3859 30.8383 54 32.3968 54H33.4558C34.5578 54 35.6148 53.5658 36.394 52.7929C37.1733 52.02 37.6111 50.9717 37.6111 49.8786V47.5C37.6111 46.9477 38.0625 46.5 38.6194 46.5C39.1762 46.5 39.6276 46.9477 39.6276 47.5V49.8786C39.6276 51.5021 38.9774 53.0591 37.8199 54.2071C36.6625 55.3551 35.0926 56 33.4558 56H32.3968C30.3035 56 28.2958 55.1752 26.8156 53.7071C25.3353 52.239 24.5037 50.2478 24.5037 48.1715V39.4141L22.1919 41.707C21.7982 42.0976 21.1598 42.0976 20.766 41.707C20.3723 41.3165 20.3723 40.6834 20.766 40.2928L25.512 35.5857Z",
    fill: "#1B5E9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsvIcon);
export default __webpack_public_path__ + "static/media/uploadCSVIcon.735790654d20111b59c78f04bc2bfa42.svg";
export { ForwardRef as ReactComponent };